import React, {
  useCallback,
  Fragment,
  useRef,
  useEffect,
  useState,
} from "react";
import axios from "axios";
import { CONTENT_ROUTES } from "../routes/content-routes";
import Header from "../components/header";
import Footer from "../components/footer";
import { NavLink } from "react-router-dom";
import { WEB_ROUTES } from "../routes/web-routes";
import NewsItemLanding from "../components/news-item-landing";
import { Helmet } from "react-helmet";
import { useUtilities } from "../hooks/utilities";
// import Swiper core and required modules
import {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from "swiper/modules";
// import Swiper bundle with all modules installed
import { Swiper, SwiperSlide } from "swiper/react";
// import styles bundle
import "swiper/css/bundle";
import DivisionsScroller from "../components/divisions-scroller";

export default function Home() {
  const [page, setPage] = useState({});
  const [childPages, setChildPages] = useState([]);
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState({});
  const [pageMedia, setPageMedia] = useState([]);
  const [banners, setBanners] = useState([]);
  const [bannerMedia, setBannerMedia] = useState([]);
  let { getMetaSnippet, getSeoTitle, getSeoDescription } = useUtilities();

  useEffect(() => {
    axios
      .get(CONTENT_ROUTES.POST_PAGE("/pages", "welcome-to-nant-power"))
      .then((res) => {
        const pageResponse = res.data?.length ? res.data[0] : {};
        setPage(pageResponse);

        //Get page media
        axios
          .get(CONTENT_ROUTES.MEDIA_BY_PAGE(pageResponse?.id))
          .then((res) => {
            setPageMedia(res.data);
          });

        //Get child pages
        axios
          .get(
            CONTENT_ROUTES.POST_PAGE_BY_PARENT(
              "/pages",
              pageResponse?.id + "&_embed",
            ),
          )
          .then((res) => {
            setChildPages(res.data);
          });
      })
      .catch((err) => {})
      .finally(() => {});
  }, []);

  useEffect(() => {
    axios
      .get(
        CONTENT_ROUTES.POST_PAGE(
          "/posts",
          "&_embed&order_by=menu_order&order=desc&per_page=100",
        ),
      )
      .then((res) => {
        setPosts(res.data);
      })
      .catch((err) => {})
      .finally(() => {});
  }, []);

  useEffect(() => {
    //Get banners
    axios
      .get(CONTENT_ROUTES.BANNERS("?order_by=menu_order&order=asc"))
      .then((res) => {
        console.log(res.data);
        setBanners(res.data);

        //Get banner media
        let media = [];

        res.data?.map((banner, i) => {
          if (banner?.featured_media)
            axios
              .get(CONTENT_ROUTES.MEDIA_BY_ID(banner?.featured_media))
              .then((res) => {
                media[i] = res.data;
                setBannerMedia((prevState) => [...prevState, media[i]]);
              });
          return banner?.featured_media;
        });
      })
      .catch((err) => {})
      .finally(() => {});
  }, []);

  const sliderRef = useRef(null);

  const handleMainSliderPrev = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slidePrev();
  }, []);

  const handleMainSliderNext = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slideNext();
  }, []);

  return (
    <>
      <Helmet>
        <title>{getSeoTitle(page, `The Nant Power Project`)}</title>
        <meta
          name="description"
          content={getSeoDescription(
            page,
            getMetaSnippet(page?.content?.rendered)
          )}
        />
      </Helmet>
      <Header />
      <main>
        <div className="relative ">
          <div className="absolute top-24 left-0 w-full h-full bg-gradient-to-bl from-0% from-[#0090ca] to-50% to-[#0071b9]  z-0">
            <div
              className="w-10/12 h-1/2 float-right bg-right-top bg-cover bg-no-repeat [mask-image:linear-gradient(to_bottom_left,black_0%,transparent_55%)]"
              style={{
                backgroundImage: `url(/images/primary-pattern.svg)`,
              }}
            ></div>
          </div>

          <section className="flex justify-end">
            <div className="container mx-auto relative banner w-full ">
              <Swiper
                ref={sliderRef}
                modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
                effect="gl"
                /* onBeforeInit={(swiper) => (swiper.params.gl.shader = "morph-x")} */
                slidesPerView={1}
                navigation
                direction={"horizontal"}
                loop={true}
                speed={1000}
                autoplay={{
                  delay: 5000,
                  disableOnInteraction: false,
                }}
              >
                {banners?.map((banner, i) => (
                  <SwiperSlide
                    key={i}
                    className="swiper-slide content-stretch items-center relative"
                  >
                    <div className="absolute z-10 bottom-0 left-0 w-full h-1/2 bg-gradient-to-t from-black/60 to-transparent"></div>
                    <div className="md:w-1/3 w-full absolute z-30 md:bottom-20 bottom-10 md:left-20 md:px-0 px-8 text-white">
                      <h2
                        className="md:text-4xl text-2xl font-medium mb-4 leading-7"
                        dangerouslySetInnerHTML={{
                          __html: banner?.title?.rendered,
                        }}
                      />
                      <div
                        dangerouslySetInnerHTML={{
                          __html: banner?.content?.rendered?.replace(
                            /<p>/g,
                            "<p class='mb-4'>",
                          ),
                        }}
                      />

                      {banner?.acf?.banner_cta?.title && (
                        <>
                          <NavLink
                            to={banner?.acf?.banner_cta?.url}
                            className="hidden md:inline-block text-xl text-white md:font-medium"
                          >
                            {banner?.acf?.banner_cta?.title}{" "}
                            <i className="fi fi-rr-arrow-right text-xl float-right mt-1 ml-1.5"></i>
                          </NavLink>

                          <NavLink
                            to={banner?.acf?.banner_cta?.url}
                            className="md:hidden inline-block text-xl text-white md:font-medium"
                          >
                            {banner?.acf?.banner_cta?.title}{" "}
                            <i className="fi fi-rr-arrow-right text-xl float-right mt-1 ml-1.5"></i>
                          </NavLink>
                        </>
                      )}
                    </div>
                    <div className="w-full h-full relative">
                      <div
                        className="image bg-center bg-cover bg-no-repeat"
                        style={{
                          backgroundImage: `url(${
                            bannerMedia?.find(
                              (media) => media.id === banner?.featured_media,
                            )?.source_url
                          })`,
                        }}
                      ></div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>

              <div
                onClick={handleMainSliderPrev}
                className="swiper-button-prev rounded-full !w-12 !h-12 bg-[#58b947] -ml-6"
              >
                <i className="fi fi-br-angle-left text-2xl text-white inline-block mt-2 mr-1"></i>
              </div>
              <div
                onClick={handleMainSliderNext}
                className="swiper-button-next rounded-full !w-12 !h-12 bg-[#58b947] -mr-6"
              >
                <i className="fi fi-br-angle-right text-2xl text-white inline-block mt-2 ml-1"></i>
              </div>
            </div>
          </section>

          <section className="relative text-white">
            <div className="container mx-auto">
              <div className="md:w-full flex content-center pt-20 md:pb-24 pb-12 md:px-0 px-8 ">
                <div className="md:flex">
                  <div className="flex md:w-4/12 pr-8 md:mb-0 mb-8">
                    <img
                      className="md:mx-5 mr-5 ml-0 h-12 -mt-2"
                      src="/images/electric-bolt-solid.svg"
                      alt="Nant Power Project Icon"
                    />
                    <h1
                      className="text-xl font-bold"
                      dangerouslySetInnerHTML={{
                        __html: page?.title?.rendered,
                      }}
                    />
                  </div>
                  <div className="md:w-7/12">
                    <h2
                      className="pb-8 md:text-4xl text-2xl font-medium"
                      dangerouslySetInnerHTML={{
                        __html: page?.content?.rendered
                          ?.replace(/<p.*?>*?<\/p>/g, "")
                          ?.replace(/<h2.*?>/g, ""),
                      }}
                    />

                    <div
                      className="mb-8 "
                      dangerouslySetInnerHTML={{
                        __html: page?.content?.rendered
                          ?.replace(/<h2.*?>*?<\/h2>/g, "")
                          ?.replace(/<p>/g, "<p class='mb-4'>"),
                      }}
                    />

                    <NavLink
                      to={WEB_ROUTES.ABOUT}
                      className="text-white font-medium py-2 px-4 bg-gradient-to-r from-transparent to-[#009ad0] inline-block"
                    >
                      Read more about Nant Power{" "}
                      <i className="fi fi-rr-arrow-right text-xl float-right mt-1 ml-1.5"></i>
                    </NavLink>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="relative pb-16 text-white">
            <div className="mx-auto container ">
              {childPages?.map((child, i) => (
                <Fragment key={i}>
                  {child.slug === "nant-power-stats" && (
                    <>
                      <div className="mx-auto flex text-center rounded-tl-[30px] rounded-tr-[30px] bg-gradient-to-b from-[#093f6a] to-[#0e619d] divide-x divide-[#0070b9]">
                        <div className="md:w-1/3 rounded-tl-[30px] bg-gradient-to-b from-[#065288] to-[#0968aa]">
                          <div className="xl:px-20 lg:px-12 md:px-12 px-4 md:py-12 py-4 h-full">
                            <h3 className="font-bold mb-2 xl:text-6xl lg:text-5xl md:text-4xl text-2xl text-[#58b947]">
                              <span className="font-bold mb-2 md:text-3xl text-base">
                                {child?.acf?.card_title_1.split(" ")[0]}
                              </span>{" "}
                              {child?.acf?.card_title_1.split(" ")[1]}
                            </h3>
                            <p className="font-medium md:text-xl text-base">
                              {child?.acf?.card_body_1}
                            </p>
                          </div>
                        </div>

                        <div className="md:w-1/3">
                          <div className="xl:px-20 lg:px-12 md:px-12 px-4 md:py-12 py-4 h-full">
                            <h3 className="font-bold mb-2 xl:text-6xl lg:text-5xl md:text-4xl text-2xl text-[#58b947]">
                              {child?.acf?.card_title_2}
                            </h3>
                            <p className="font-medium md:text-xl text-base">
                              {child?.acf?.card_body_2}
                            </p>
                          </div>
                        </div>

                        <div className="md:w-1/3 rounded-tr-[30px] ">
                          <div className="xl:px-20 lg:px-12 md:px-12 px-4 md:py-12 py-4 h-full">
                            <h3 className="font-bold mb-2 xl:text-6xl lg:text-5xl md:text-4xl text-2xl text-[#58b947]">
                              {child?.acf?.card_title_3}
                            </h3>
                            <p className="font-medium md:text-xl text-base">
                              {child?.acf?.card_body_3}
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="w-full bg-gradient-to-b from-[#0968aa] to-transparent ">
                        <div className="max-w-5xl md:px-20 px-8 pb-8 md:pt-12 pt-8">
                          {/* <h2
                        className="text-4xl font-medium mb-4"
                        dangerouslySetInnerHTML={{
                          __html: child?.title?.rendered,
                        }}
                      /> */}
                          <div
                            className=""
                            dangerouslySetInnerHTML={{
                              __html: child?.content?.rendered,
                            }}
                          />
                        </div>
                      </div>
                    </>
                  )}
                </Fragment>
              ))}
            </div>
          </section>
        </div>

        <section
          className="relative bg-no-repeat md:bg-left-top bg-right-bottom md:bg-[length:100%_auto] bg-gradient-to-br from-[#194e7c] to-[#0c67a5]"
          /* style={{
            backgroundImage: `url(
              ${
                pageMedia?.find((media) => media?.id === page?.featured_media)
                  ?.source_url
              }
            )`,
          }} */
        >
          {childPages?.map((child, i) => (
            <Fragment key={i}>
              {child.slug === "sustainability-and-business-integrity" && (
                <div className="container mx-auto md:flex">
                  <div className="md:w-1/2 md:px-20 px-8 py-20 text-white">
                    <h2
                      className="pb-8 text-4xl font-medium text-[#58b947]"
                      dangerouslySetInnerHTML={{
                        __html: child?.title?.rendered,
                      }}
                    />
                    <div
                      className="mb-8 "
                      dangerouslySetInnerHTML={{
                        __html: child?.content?.rendered.replace(
                          /<p>/g,
                          "<p class='mb-4'>",
                        ),
                      }}
                    />

                    <NavLink
                      to={WEB_ROUTES.IMPACT}
                      className="text-[#58b947] inline-block text-xl"
                    >
                      Learn more{" "}
                      <i className="fi fi-rr-arrow-right text-xl float-right mt-1 ml-1.5"></i>
                    </NavLink>
                  </div>
                  <div
                    className="md:absolute relative md:h-full h-96 md:w-1/2 w-full z-0 top-0 right-0 image bg-center bg-cover bg-no-repeat"
                    style={{
                      backgroundImage: `url(${child?._embedded["wp:featuredmedia"][0]?.source_url})`,
                    }}
                  >
                    <img
                      src="/images/electric-bolt-outline.svg"
                      alt="Bolt"
                      className="absolute md:h-[550px] h-[500px] md:w-auto w-full z-10 md:-top-14 bottom-0 p-0 md:right-[25%]"
                    />
                  </div>
                </div>
              )}
            </Fragment>
          ))}
        </section>

        <section className="relative bg-white md:pb-16">
          <div className="container mx-auto">
            <div className="md:w-full flex content-center pt-16 pb-8 md:px-0 px-8">
              {childPages?.map((child, i) => (
                <Fragment key={i}>
                  {child.slug === "why-this-project-matters" && (
                    <div key={i} className="md:flex">
                      <div className="flex md:w-4/12 pr-8 md:mb-0 mb-8">
                        <img
                          className="mr-5 h-12 -mt-2"
                          src="/images/electric-bolt-solid.svg"
                          alt="Nant Power Project Icon"
                        />
                        <span className="text-xl font-bold text-gray-500">
                          Impact
                        </span>
                      </div>
                      <div className="md:w-6/12">
                        <h2
                          className="pb-8 text-4xl font-medium text-[#0070b9]"
                          dangerouslySetInnerHTML={{
                            __html: child?.title?.rendered,
                          }}
                        />
                        <div
                          dangerouslySetInnerHTML={{
                            __html: child?.content?.rendered.replace(
                              /<p>/g,
                              "<p class='mb-4'>",
                            ),
                          }}
                        />
                        <NavLink
                          to={WEB_ROUTES.PROJECT}
                          className="text-[#58b947] inline-block text-xl"
                        >
                          Learn more{" "}
                          <i className="fi fi-rr-arrow-right text-xl float-right mt-1 ml-1.5"></i>
                        </NavLink>
                      </div>
                    </div>
                  )}
                </Fragment>
              ))}
            </div>
          </div>
        </section>

        <section className="relative pb-16 bg-gradient-to-b from-transparent to-[#bad8ec]">
          <div className="container mx-auto">
            <div className="text-2xl font-bold text-[#58b947] mb-8 md:mx-0 mx-8 ">
              Key Benefits Include
            </div>
            <div>
              {childPages?.map((child, i) => (
                <Fragment key={i}>
                  {child.slug === "key-benefits" && (
                    <>
                      <div className="mx-auto md:flex text-white ">
                        {Array.from({ length: 4 }).map((_, i) => {
                          const titleKey = `card_title_${i + 1}`;
                          const bodyKey = `card_body_${i + 1}`;

                          return (
                            <div
                              key={i}
                              className={`md:w-1/3 ${
                                i % 2 === 0 ? "bg-[#58b947]" : "bg-[#399d5b]"
                              } p-10`}
                            >
                              <div className="font-medium mb-10">0{i + 1}</div>
                              <div className="font-medium mb-4 text-2xl">
                                {child?.acf?.[titleKey]}
                              </div>
                              <p>{child?.acf?.[bodyKey]}</p>
                            </div>
                          );
                        })}
                      </div>
                    </>
                  )}
                </Fragment>
              ))}
            </div>
          </div>

          <div className="container mx-auto">
            <div className="pt-16 md:px-0 px-8">
              <div className="flex mb-8">
                <img
                  className="mr-5 h-12 -mt-2"
                  src="/images/electric-bolt-solid.svg"
                  alt="Nant Power Project Icon"
                />
                <span className="text-xl font-bold text-gray-500">
                  Key Partners and Lenders
                </span>
              </div>
              <div>
                <DivisionsScroller />
              </div>
            </div>
          </div>
        </section>

        <section className="bg-[#0070b9] py-16 md:border-none border-t ">
          <div className="mx-auto container md:px-0 px-8">
            <div className="mx-full">
              <h2 className="text-4xl font-medium float-left text-white mb-4 md:m-0">
                News and Media
              </h2>

              <NavLink
                to={WEB_ROUTES.NEWS}
                className="text-[#58b947] font-medium text-xl md:inline-block float-right hidden mt-0.5"
              >
                More news{" "}
                <i className="fi fi-rr-arrow-right text-xl float-right mt-1 ml-1.5"></i>
              </NavLink>
              <div className="clear-both"></div>
            </div>
            <div className="mx-auto md:mt-16 mt-5 grid max-w-2xl grid-cols-1 gap-x-8 md:gap-y-20 gap-y-10 lg:mx-0 lg:max-w-none lg:grid-cols-4">
              {posts?.slice(0, 4).map((article, i) => (
                <Fragment key={i}>
                  <NewsItemLanding article={article} />
                </Fragment>
              ))}
            </div>
            <div className="mx-full md:pt-0 pt-10">
              <NavLink
                to={WEB_ROUTES.NEWS}
                className="text-[#58b947] font-medium text-xl inline-block md:float-right md:hidden"
              >
                More news{" "}
                <i className="fi fi-rr-arrow-right text-xl float-right mt-1 ml-1.5"></i>
              </NavLink>
              <div className="clear-both"></div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
